import { createContext } from 'react';

export type ToastsContextType = {
  showToast: (translationKey: string, options?) => void;
};

export const ToastsContext = createContext<ToastsContextType>({
  showToast: () => null,
});
